import { render, staticRenderFns } from "./TopicoCursoExpirado.vue?vue&type=template&id=0f9b1c8a"
import script from "./TopicoCursoExpirado.vue?vue&type=script&lang=js"
export * from "./TopicoCursoExpirado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports